import React from 'react';
import { useAppSelector } from '../../../../hooks';
import { StateController } from './ShopperExperience/useStateControllerRef';
import { AppRoute, AppSwitch, PermittedRouteMap } from '../../../../app-routes';
import { SideMenuPreview } from './SideMenuPreview';
import { SideMenuEdit } from './SideMenuEdit';
import { useNavigateToVisualEditorRoute } from '../../hooks/useNavigateToVisualEditorRoute';
import { SettingsContainer } from './SideMenu.styles';

interface Props {
  shopId: number;
  setForInternalUseOnly: boolean;
  closeModal: VoidFunction;
  stateController: StateController<any>;
  permittedRouteMap: PermittedRouteMap;
  resultsScreenRef: React.MutableRefObject<HTMLDivElement>;
  openProductDetailsModal: (sku?: string) => void;
  locale: string;
}

export function SideMenuSettings({
  shopId,
  setForInternalUseOnly,
  closeModal,
  stateController,
  permittedRouteMap,
  resultsScreenRef,
  openProductDetailsModal,
  locale,
}: Props): JSX.Element {
  const { selectedRule } = useAppSelector(state => state.visualEditor.merchandisingRules);
  const selectedExperience = useAppSelector(state => state.visualEditor.selectedExperience);
  const { categoryFilterRule } = useAppSelector(state => state.visualEditor);

  const { navigateToVisualEditorRoute: navigateToEditRankingStrategy } =
    useNavigateToVisualEditorRoute({
      route: permittedRouteMap?.visualEditorEditRankingStrategy,
    });

  const { navigateToVisualEditorRoute: navigateToEditRelevancyTuning } =
    useNavigateToVisualEditorRoute({
      route: permittedRouteMap?.visualEditorEditRelevancyTuning,
    });

  const { navigateToVisualEditorRoute } = useNavigateToVisualEditorRoute({
    route: permittedRouteMap?.visualEditor,
  });

  return (
    <SettingsContainer>
      <AppSwitch>
        <AppRoute
          route={permittedRouteMap.visualEditorEdit}
          Component={SideMenuEdit}
          componentProps={{
            setForInternalUseOnly,
            onClose: () => navigateToVisualEditorRoute({ shopId }),
            selectedRule,
            shopId,
            stateController,
            permittedRouteMap,
            locale,
          }}
          exact={false}
        />
        <SideMenuPreview
          shopId={shopId}
          stateController={stateController}
          setForInternalUseOnly={setForInternalUseOnly}
          onClose={closeModal}
          selectedRule={selectedRule}
          editRankingStrategy={() => navigateToEditRankingStrategy({ shopId })}
          navigateToEditRelevancyTuning={() => navigateToEditRelevancyTuning({ shopId })}
          permittedRouteMap={permittedRouteMap}
          resultsScreenRef={resultsScreenRef}
          selectedExperience={selectedExperience}
          openProductDetailsModal={openProductDetailsModal}
          categoryFilterRule={categoryFilterRule}
          locale={locale}
        />
      </AppSwitch>
    </SettingsContainer>
  );
}
